import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function contactsReducer(state = initialState.contacts, action) {

    const mergeInContact = (contacts, contactUpdate) => {
        if (contactUpdate.id < 1) {
            return contacts;
        }
        const contactsMinusStaleData = contacts.filter(contact => contact.id !== contactUpdate.id);       
        return contactsMinusStaleData.concat(contactUpdate);
    }

     const deleteContact = (current, id) => {
        return current.filter(contact => contact.id !== id);
    } 


    switch (action.type) {
        case types.LOAD_CONTACT_SUCCESS:
        case types.UPDATED_CONTACT_SUCCESS:
            return mergeInContact(state, action.contact);
            case types.DELETED_CONTACT:      
            return deleteContact(state, action.id);      
        case types.DELETED_CONTACT_INCOMING:  
        case types.UPDATED_CONTACT_INCOMING:
            return deleteContact(state, action.payload.id);    
        default:
            return state;
    }
}

